import range from 'lodash-es/range';

export function getYears(start = new Date().getFullYear(), limit = 10) {
    return range(start, start + limit).map((year) => {
        return year;
    });
}
